<template>
  <div class="tab-panel-body">
    <!-- Header -->
    <div class="config-section-header">
      <div class="config-section-header__left">
        <v-icon small class="mr-2" color="text_secondary">mdi-view-column</v-icon>
        <span class="config-section-label">Colunas</span>
        <v-chip v-if="colunas && colunas.length" x-small class="ml-2" color="surface_tertiary">
          {{ colunas.length }}
        </v-chip>
      </div>
    </div>

    <!-- Table -->
    <DataTables
      v-if="colunas && colunas.length > 0"
      :data="colunas"
      :headers="headers"
      :itens-por-pagina="5"
      tab="colunas"
      class="colunas-table"
      :changeColuna="changeColuna"
      :num_coluna_telao="numColunaTelao"
    />

    <!-- Empty state -->
    <div v-if="colunas && colunas.length === 0" class="sc-empty-state">
      <v-icon size="40" color="text_secondary" class="mb-3">mdi-view-column-outline</v-icon>
      <span class="sc-empty-state__title">Nenhuma coluna configurada</span>
      <span class="sc-empty-state__subtitle">As colunas são configuradas automaticamente pela produção</span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DataTables from "@/components/DataTables.vue";

export default {
  name: "ConfigTabColunas",
  components: { DataTables },
  props: {
    codProducao: { type: Number, required: true },
    changeColuna: { type: Function, default: null },
    numColunaTelao: { type: Number, default: null },
    active: { type: Boolean, default: false },
  },
  watch: {
    active: {
      immediate: true,
      handler(isActive) {
        if (isActive) this.fetch();
      },
    },
    codProducao() {
      if (this.active) this.fetch();
    },
  },
  computed: {
    ...mapGetters({
      colunas: "colaboracoes_moderadas/getterColunas",
    }),
  },
  data() {
    return {
      headers: [
        {
          text: "Nome da Coluna",
          align: "start",
          sortable: false,
          name: "dsc_coluna",
          class: " subtitle-1 font-weight-bold text-center",
          value: "name",
        },
        {
          text: "Número da Coluna",
          align: "start",
          sortable: false,
          name: "num_coluna_telao",
          class: " subtitle-1 font-weight-bold text-center",
          value: "name",
        },
        {
          text: "Ativo",
          align: "start",
          sortable: false,
          name: "flg_ativo",
          class: " subtitle-1 font-weight-bold text-center",
          value: "name",
        },
        {
          text: "Ações",
          sortable: false,
          name: "actions",
          align: "end",
          class: "subtitle-1 font-weight-bold pr-7",
          value: "name",
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      getColunas: "colaboracoes_moderadas/getColunas",
    }),
    async fetch() {
      await this.getColunas({ cod_producao: this.codProducao });
    },
  },
};
</script>

<style lang="scss" scoped>
.colunas-table {
  border-radius: var(--sc-radius-lg);
  overflow: hidden;
}

::v-deep .colunas-table tbody td {
  height: 72px !important;
}

</style>
